@if (initialized) {
  @for (test of materialTests; track test) {
    <div>
      <mat-checkbox
        [disabled]="!('manage-project-test' | able: project)"
        [checked]="test.checked"
        (change)="onChange(test, $event.checked)">
        {{test.name}}
      </mat-checkbox>
    </div>
  }
}
